import React, { isValidElement } from 'react'
import PropTypes from 'prop-types'
import { CardHeader, Grid } from '@mui/material'
import { isUndefined } from 'lodash'
import { Action } from 'common/components/action/Action'
import { getTextColorByHexColor } from 'common/utils/ColorUtil'

const Title = ({
    title = '',
    subTitle = '',
    subtitleSize = 2,
    actions = [],
}) => {
    const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
    return (
        <Grid container spacing={2} alignItems='center' sx={{ height: '36px' }}>
            <Grid size='grow'>
                {isValidElement(title) ? title : (<span style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>{title}</span>)}
            </Grid>
            {!!subTitle && (
                <Grid size={subTitle ? subtitleSize : 'auto'}>
                    {isValidElement(subTitle) ? subTitle : (<span style={{ fontSize: '1.3rem' }}>{subTitle}</span>)}
                </Grid>
            )}
            {filteredActions.length > 0 && (
                <Grid container size='auto' spacing={0.5}>
                    {filteredActions.map(action => (
                        <Grid key={actions.indexOf(action)} size='auto'>
                            {isValidElement(action) ? action : (<Action {...action} />)}
                        </Grid>
                    ))}
                </Grid>
            )}
        </Grid>
    )
}

Title.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitleSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.string,
            onClick: PropTypes.func,
            color: PropTypes.string,
            displayed: PropTypes.bool,
            pulse: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
    fontColor: PropTypes.string,
}

const CardTitle = ({
    title = '',
    subTitle = '',
    subtitleSize = 2,
    actions = [],
    color = '#cce6ff',
    sx = {},
}) => (
    <CardHeader
        title={<Title title={title} subTitle={subTitle} actions={actions} subtitleSize={subtitleSize} />}
        disableTypography
        sx={{
            backgroundColor: color,
            color: getTextColorByHexColor(color),
            paddingLeft: '20px',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            ...sx,
        }}
    />
)

CardTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitleSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.string,
            onClick: PropTypes.func,
            color: PropTypes.string,
            displayed: PropTypes.bool,
            pulse: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
    color: PropTypes.string,
    sx: PropTypes.shape({}),
}

export { CardTitle }